
export const tableItem = (selector, recCol, recText) => {
    //Function to find recommended column and add class to all tds
    if (typeof selector !== 'string') {
        return
    }
    const parent = document.querySelector(selector);
    const headerTR = parent.querySelector(".comparison-table tr.headerTr");
    var recommendedcol = recCol;
    const isComparisonTable = !!parent.querySelector('.comparison-table');
    var addClasses = function () {
        if (recommendedcol === "0") return;
        var trCollectiontop = parent.querySelector(".comparison-table tr.top");
        const trCollectiontop0 = trCollectiontop.children[recommendedcol - 1];
        const trCollectiontop1 = headerTR.children[recommendedcol - 1];
        trCollectiontop0.textContent = recText;
        trCollectiontop0.classList.remove("hide");
        trCollectiontop0.classList.add("default", "recommended", "top");
        trCollectiontop1.classList.add("default", "recommended");
    }

    const setSeperator = (largeTable, tableSpanWidth) => (element) => {
        element.classList.toggle("separator-flex", largeTable);
        if (largeTable) {
            element.children[0].classList.add("stickRow");
            element.children[0].children[0].setAttribute("style", `width: ${tableSpanWidth}px;`);
        } else {
            element.children[0].classList.remove("stickRow");
            element.children[0].classList.add("recommended");
            element.children[0].children[0].removeAttribute("style");
        }
    }

    const addBlockClass = function () {
        if (recommendedcol === "0") return;

        const wrapperWidth = parent.offsetWidth;
        const tableWidth = parent.querySelector(".comparison-table").offsetWidth;
        const trSeperator = parent.querySelectorAll(".comparison-table tr.separator");
        const tableSpanWidth = wrapperWidth;
        trSeperator.forEach(setSeperator(tableWidth > wrapperWidth, tableSpanWidth))
    }
    //comparisontable functions

    var fixRecommendedCol = function () {
        if (recommendedcol === "0") return;
        var wrapper = parent.offsetWidth;
        var table = parent.querySelector(".comparison-table").offsetWidth;
        var trCollection = parent.querySelectorAll("table.comparison-table tr:not(.separator)");
        let recommendedColumnIndex = recommendedcol - 1;
        for (var j = 0; j < trCollection.length; j++) {
            if (table > wrapper) {
                //add static class to table td's
                trCollection[j].children[recommendedColumnIndex].classList.add("first-fixed", "default", "recommended");
            } else {
                //Set recommended column back to initial
                trCollection[j].children[recommendedColumnIndex].classList.remove("first-fixed");
                trCollection[j].children[recommendedColumnIndex].classList.add("default", "recommended");
            }

        }
    };
    //Replace checkmarks function on load

    var tick = parent.querySelectorAll('span.tick:not(.false)');
    for (var tf = 0; tf < tick.length; tf++) {
        tick[tf].classList.add("ikon-checkmark-til-sirkel-36");
        tick[tf].setAttribute("title", "Valgfritt");
        tick[tf].setAttribute("aria-hidden", "true");
        tick[tf].innerHTML = "";
    }

    var tickfull = parent.querySelectorAll('span.tick.full');
    for (var t = 0; t < tickfull.length; t++) {
        tickfull[t].classList.add("ikon-checkmark-til-sirkel-36");
        tickfull[t].setAttribute("title", "Anbefales");
        tickfull[t].setAttribute("aria-hidden", "true");
        tickfull[t].innerHTML = "";
    }

    var tickfalse = parent.querySelectorAll('span.tick.false');
    for (var tx = 0; tx < tickfalse.length; tx++) {
        tickfalse[tx].classList.add("ikon-kryss-36");
        tickfalse[tx].setAttribute("aria-hidden", "true");
        tickfalse[tx].setAttribute("title", "Anbefales ikke");
        tickfalse[tx].innerHTML = "";
    }

    var setCustomAttr = parent.querySelectorAll('.comparison-table span.tick:not(.false)');
    setCustomAttr.forEach(element => element.setAttribute("title", "Dekkes"));
    var setCustomAttrFalse = parent.querySelectorAll('.comparison-table span.tick.false');
    setCustomAttrFalse.forEach(element => element.setAttribute("title", "Dekkes ikke"));

    const addScrollIndicators = function () {
        var wrapperWidthforscroll = parent.offsetWidth;
        var tableWidthforscroll = parent.querySelector(".main-table").offsetWidth;
        if (tableWidthforscroll > wrapperWidthforscroll) {
            parent.querySelector('.table-scroll').classList.add('horizontal-scroll', 'tablereordering');
        } else {
            parent.querySelector('.table-scroll').classList.remove('horizontal-scroll', 'horizontal-scroll-before', 'tablereordering');
        }
    }

    const scrollEventOnIndicators = function () {
        parent.querySelector('.table-wrap').addEventListener("scroll", function () {
            if (parent.querySelector(".table-wrap").scrollLeft > 2) {
                parent.querySelector('.table-scroll').classList.add('horizontal-scroll-off-right', 'horizontal-scroll-before');
                parent.querySelector('.table-scroll').classList.remove('horizontal-scroll');
            } else {
                parent.querySelector('.table-scroll').classList.remove('horizontal-scroll-off-right', 'horizontal-scroll-before');
                parent.querySelector('.table-scroll').classList.add('horizontal-scroll');
            }
        });
    }

    if (isComparisonTable) {
        addClasses();
        fixRecommendedCol();
        addBlockClass();
        window.addEventListener("resize", fixRecommendedCol);
        window.addEventListener("resize", addBlockClass);
    }
    addScrollIndicators();
    scrollEventOnIndicators();
    window.addEventListener("resize", addScrollIndicators);
};